import { getMessage } from "common/messageUtil";
import { magiContants } from "utils/contants";

export interface MCBNS020AutoReservationRemindInfo {
  seminarId: number; // セミナーID
  coordinationFormerSeminarId: string; // 連携元セミナーID
  seminarName: string; // セミナー名
  publicFlag: string; // 公開フラグ
  studentDisplayEnd: boolean // 学生に表示される期間終わったフラグ
  displayStartDate: Date | null; // 表示開始日
  displayEndDate: Date | null; // 表示終了日
  remindPreference1: string; // リマインド設定１
  messageTemplateSettingId1: string; // メッセージテンプレート設定ID１
  deliveryTiming1: string; // 配信タイミング１
  sysVersionNumber1: number; // sysバージョン番号１
  remindPreference2: string; // リマインド設定２
  messageTemplateSettingId2: string; // メッセージテンプレート設定ID２
  deliveryTiming2: string; // 配信タイミング２
  sysVersionNumber2: number; // sysバージョン番号２
  messageTemplateList: MCBNS020MessageTemplateInfoOutDto[]; // メッセージテンプレートリスト
}

export interface MCBNS020MessageTemplateInfoOutDto {
  messageTemplateSettingId: number; // メッセージテンプレート設定ID
  templateName: string; // テンプレート名
  sequence: number; // 連番
}

export const initialMCBNS020AutoReservationRemindInfo: MCBNS020AutoReservationRemindInfo = {
  seminarId: 0,
  coordinationFormerSeminarId: "",
  seminarName: "",
  publicFlag: "",
  studentDisplayEnd: false,
  displayStartDate: null,
  displayEndDate: null,
  remindPreference1: "",
  messageTemplateSettingId1: '',
  deliveryTiming1: "",
  sysVersionNumber1: 0,
  remindPreference2: "",
  messageTemplateSettingId2: '',
  deliveryTiming2: "",
  sysVersionNumber2: 0,
  messageTemplateList: []
}

export const remindPreferenceList = [
  { value: '1', label: '配信する' },
  { value: '0', label: '配信しない' },
]

export const deliveryTimingList = [
  { value: '01', label: '開催日前日' },
  { value: '02', label: '開催日2日前' },
  { value: '03', label: '開催日3日前' },
  { value: '04', label: '開催日4日前' },
  { value: '05', label: '開催日5日前' },
  { value: '06', label: '開催日6日前' },
  { value: '07', label: '開催日7日前' },
]

export const alertMessageMap = {
  update: getMessage(magiContants.MESSAGECODE_MCBNS020_011),
  cancel: getMessage(magiContants.MESSAGECODE_MCBNS020_002),
  notDeliveryCheck: getMessage(magiContants.MESSAGECODE_MCBNS020_003),
}